import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import SearchBox from '../courses/searchBox';
import { fetchRequest as getCourseRecomAction} from '../../store/courseRecommend/actions'
import { getCourseRecom } from '../../store/courseRecommend/selectors';
import {
    Container, Col, Row, Card, CardImg, CardTitle, CardText, CardGroup, CardFooter,
    CardSubtitle, CardBody, Spinner, Button
} from 'reactstrap';
import { NavLink as RouterNavLink } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.css';
import { Redirect } from 'react-router-dom';

interface PropsFromState {
    route: any
    data: any
    loading: boolean
    totalDoc: number
}

interface IState {
    redirect: boolean
    term : string
    profession : string
    country : string
    sorting : string
    offset: number
    limit: number
}

interface PropsFromDispatch {
    fetchRequest : typeof getCourseRecomAction
}

type AllProps = PropsFromState & PropsFromDispatch

class ContactUs extends React.Component<AllProps, IState> {

    constructor(props: AllProps) {
        super(props);
        this.state = {
            term : '',
            profession : '',
            country:'',
            sorting: '',
            offset : 0,
            limit: 4,
            redirect: false
        };
        //this.Search = this.Search.bind(this);
    }

    public componentDidMount() {
        const { fetchRequest: fr, data } = this.props
        var searchParams:any = {};
        searchParams["offset"] = this.state.offset;
        searchParams["limit"] = this.state.limit;
        if (data.length === 0)
           fr(searchParams);
    }

    private Search(d:any) { 

       this.setState({
            offset : 0, 
            redirect : true,
            term : d.searchTerm.toLowerCase(), 
            profession : d.searchProfession, 
            country : d.searchCountry}, () => {
        });
    }
   
    public render() {

        if (this.state.redirect){
            return (
                <Redirect push to={{
                    pathname: '/courses/' ,
                    search :'?term=' + this.state.term  + "&profession=" + encodeURIComponent(this.state.profession) + "&country=" + this.state.country    
                }} />
                // <Redirect to={"/courses?term=" + this.state.term 
                //     + "&profession=" + this.state.profession
                //     + "&country=" + this.state.country    
                //  } />
            )
        }else{
            return (        
                <Container>
                   <h1>Contact Us</h1>
                   <hr/>
                   <p>
                   Email : <a href="mailto:feedback@ultimatespro.com">feedback@ultimatespro.com</a>
                   </p>
                   <p>
                   <strong>Transpromation Sdn Bhd</strong><br/>
                   202001008521 (1364841-W)<br/>
                   Level 8, 33B, <br/>
                   Jalan Pahang, 10400, Penang.
                   </p>
                   <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
                </Container>
            )
        }
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    loading: state.course.ui.loading,
    totalDoc: state.course.ui.totDoc,
    errors: state.course.ui.errors,
    data: getCourseRecom(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    fetchRequest: getCourseRecomAction
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContactUs)
